import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, BoxProps, InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DownloadingIcon from "@mui/icons-material/Downloading";

const FontAwesomeIconsBox = styled(Box)(({ theme }) => ({
    color: theme.palette.grey[600],
    fontSize: "22px",
}));

const MaterialIconsBox = styled(Box)(({ theme }) => ({
    color: theme.palette.grey[600],
    fontSize: "25px",
    display: "flex",
}));

const SecondaryMaterialIconsBox = styled(MaterialIconsBox)({
    marginTop: "15px",
});

export const AppDownloadingIcons = (props: AppDownloadingIconsProps) => {
    const { className, iconType, addMargin, isFloating, ...rest } = props;

    const fontAwessomeIconList = ["download", "trash"];
    const materialIconList = ["in-progress", "queued"];

    if (fontAwessomeIconList.includes(iconType)) {
        if (iconType === "download")
            return (
                <Box
                    component={isFloating ? "div" : FontAwesomeIconsBox}
                    sx={isFloating ? {} : undefined}
                    {...rest}
                >
                    <FontAwesomeIcon icon={["fas", "download"]} />
                </Box>
            );
        else
            return (
                <Box
                    component={isFloating ? "div" : FontAwesomeIconsBox}
                    sx={isFloating ? {} : undefined}
                    {...rest}
                >
                    <FontAwesomeIcon icon={["fas", "trash"]} />
                </Box>
            );
    }
    if (materialIconList.includes(iconType)) {
        if (iconType === "in-progress") {
            return addMargin ? (
                <SecondaryMaterialIconsBox {...rest}>
                    <DownloadingIcon />
                </SecondaryMaterialIconsBox>
            ) : (
                <MaterialIconsBox {...rest}>
                    <DownloadingIcon />
                </MaterialIconsBox>
            );
        } else {
            return addMargin ? (
                <SecondaryMaterialIconsBox {...rest}>
                    <HourglassEmptyIcon />
                </SecondaryMaterialIconsBox>
            ) : (
                <MaterialIconsBox {...rest}>
                    <HourglassEmptyIcon />
                </MaterialIconsBox>
            );
        }
    }

    return <></>;
};

export type AppIconType = "download" | "in-progress" | "queued" | "trash";

export interface AppDownloadingIconsProps
    extends InternalStandardProps<BoxProps> {
    iconType: AppIconType;
    addMargin?: boolean;
    isFloating?: boolean;
}
